<template>
  <b-modal
    ref="infoModal"
    modal-class="info-modal"
    size="sm">
    <div class="text-center">
      <h5>{{ message }}</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'InfoModal',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    show() {
      this.$refs.infoModal.show();
    },
    hide() {
      this.$refs.infoModal.hide();
    },
  },
};
</script>
